import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { environment } from '../../../environments/environment'
import { JSONRpcResponse } from '../../Interfaces/JSONRpcResponse'
import { JSONRpc } from '../service-jsonrpc'

@Injectable({
	providedIn: 'root',
})
export class MesVaccinService {
	constructor(private http: HttpClient) { }

	service(): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.mesvaccins:service',
			params: {
				
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	
	search(id:any, options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.mesvaccins:search',
			params: {
				id: id,
				options: options
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	
    searchbyitems(options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.mesvaccins:searchbyitems',
			params: {
				
				options: options
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	
	set(id:any,options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.mesvaccins:set',
			params: {
				id: id,
				options: options
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	
	colibri(id:any,options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.mesvaccins:colibri',
			params: {
				id: id,
				options: options
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	
	
	document(id:any,options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.mesvaccins:document',
			params: {
				id: id,
				options: options
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	
	url(id:any, type:string = "patient"): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.mesvaccins:url',
			params: {
				id: id,
				options: {
					type : type
					}
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	
}